import React from 'react';
import moment from 'moment';
import { Table } from 'antd';
import { connect } from 'dva';
import { Typography } from '@hulu/react-style-components';

import { AccountsReviewWrapper, SelectExpirationWrapper } from './styles';
import { newTestCaseColumns } from '../../../Templates/columns';
import { NEWTESTCASE_DATEPICKER, NEWTESTCASE_REVIEW } from '../../../../testUtils';
import { MomentDatePicker } from '../../../../utils';
import { OFF_PLATFORM_PUBLISHER, ROKU_FAST_PUBLISHER, FUBO_PUBLISHER } from '../../constants';

const SelectTestingFeature = ({ dispatch, profiles = [], targetKeys, endAt, setEndAt, searchParams }) => {
  const targetKeysSet = new Set(targetKeys);
  const selectedProfiles = profiles.filter((profile) => targetKeysSet.has(profile.key));
  const hasOffPlatform = selectedProfiles.some((profile) => profile.publisher === OFF_PLATFORM_PUBLISHER);
  const hasRokuFast = selectedProfiles.some((profile) => profile.publisher === ROKU_FAST_PUBLISHER);
  const hasFubo = selectedProfiles.some((profile) => profile.publisher === FUBO_PUBLISHER);
  const hasNonOffPlatform = selectedProfiles.some(
    (profile) =>
      profile.publisher !== OFF_PLATFORM_PUBLISHER &&
      profile.publisher !== ROKU_FAST_PUBLISHER &&
      profile.publisher !== FUBO_PUBLISHER
  );
  const hasEmailProfiles = selectedProfiles.some((profile) => profile.email !== undefined);

  const showEmail = hasEmailProfiles;
  const showOffPlatformFields = hasOffPlatform;
  const showAccountFields = hasNonOffPlatform;
  const showRokuFields = hasRokuFast;
  const showFuboFields = hasFubo;
  const showChannelField = selectedProfiles.some((profile) => profile.channel);

  const handleDateChange = (expTime) => {
    dispatch({
      type: 'app/setSearchParams',
      payload: { ...searchParams, expTime },
    });
    setEndAt(expTime);
  };

  const isOffPlatform = selectedProfiles.some((profile) => profile.publisher === OFF_PLATFORM_PUBLISHER);
  const defaultEndAt = isOffPlatform ? moment().add(24, 'hours') : moment(endAt);
  const maxDate = isOffPlatform ? moment().add(24, 'hours') : moment().add(1, 'month');

  return (
    <>
      <SelectExpirationWrapper data-testid={NEWTESTCASE_DATEPICKER}>
        <Typography variant="h3">Test Expiration Time</Typography>
        <br />
        <MomentDatePicker
          allowClear={false}
          defaultValue={defaultEndAt}
          showTime={{ format: 'HH:mm' }}
          format="YYYY-MM-DD HH:mm"
          placeholder="select expiration time"
          onChange={handleDateChange}
          disabledDate={(currentDate) => currentDate <= moment().subtract(1, 'days') || currentDate > maxDate}
          needConfirm={false}
        />
        <br />
      </SelectExpirationWrapper>
      {isOffPlatform && <p>IP-based traces are limited to 24 hours.</p>}
      <AccountsReviewWrapper data-testid={NEWTESTCASE_REVIEW}>
        <Typography variant="h3">Account / Profile to set up test case</Typography>
        <Table
          dataSource={selectedProfiles}
          columns={newTestCaseColumns(
            showEmail,
            showOffPlatformFields,
            showAccountFields,
            showRokuFields,
            showFuboFields,
            showChannelField
          )}
        />
      </AccountsReviewWrapper>
    </>
  );
};

function mapStateToProps({ newTestCase, app }) {
  return {
    profiles: newTestCase.accountProfileCombinations,
    searchParams: app.searchParams,
  };
}

export default connect(mapStateToProps)(SelectTestingFeature);
